import { PlatformService } from '@core/services/platform.service';
import { CaseRulesService } from '@products/dmepos/services/case-rules.service';
import { ServiceLinesRulesService } from '@products/pac/services/service-lines-rules.service';
import { ProductName } from '@core/constants';

export default (platform: PlatformService) => {
  switch (platform.currentProduct.value) {
    case ProductName.DMEPOS_MA:
    case ProductName.DMEPOS_MCD:
      return new CaseRulesService();
    default:
      return new ServiceLinesRulesService();
  }
};
